import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import {  RootWiseCostController } from "./root-wise-cost.controller";
import {  RootWiseCostService } from "./root-wise-cost.service";
import { RootWiseCostEntity } from "./root-wise-cost.entity";
import { RootWiseCostRepository } from "./root-wise-cost.repo";

@Module({
    imports: [
      TypeOrmModule.forFeature([RootWiseCostEntity]),
    ],
    controllers: [RootWiseCostController],
    providers: [RootWiseCostService,ApplicationExceptionHandler,RootWiseCostRepository]
  })
  export class RootWiseCostModule {}